import React, { useEffect, useRef } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAppDispatch from "hooks/useAppDispatch";

import {
  validateInvitationToken,
  clearValidateError,
} from "../../../../redux/features/invitation/invitationSlice";

import "./InvitationValidateGate.sass";

export default function InvitationValidateGate() {
  const { token: tokenParam } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const tokenFromQuery = searchParams.get("token");
  const token = tokenParam || tokenFromQuery;

  const validateStatus = useSelector(
    (state) => state.invitation?.validateStatus || "idle"
  );
  const validateError = useSelector(
    (state) => state.invitation?.validateError || null
  );

  const lastValidatedTokenRef = useRef(null);

  useEffect(() => {
    if (!token) {
      lastValidatedTokenRef.current = null;
      dispatch(clearValidateError());
      return;
    }

    if (lastValidatedTokenRef.current === token) return;

    dispatch(clearValidateError());
    lastValidatedTokenRef.current = token;

    dispatch(validateInvitationToken(token));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (validateStatus === "succeeded" && token) {
      navigate(`/invite/accept?token=${encodeURIComponent(token)}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateStatus, token]);

  useEffect(() => {
    const shouldShowError = (!token && validateStatus !== "loading") || validateStatus === "failed";
    
    if (shouldShowError) {
      const errorMessage = !token
        ? "Invitation token is missing"
        : validateError?.message ||
          "This invitation is invalid or has expired. Please request a new invitation.";
      
      // Navigate to SignUp page with error message in query params
      navigate(`/signup?inviteError=${encodeURIComponent(errorMessage)}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateStatus, token, validateError]);

  return (
    <div className="InvitationValidateGate">
      {validateStatus === "loading" && (
        <div className="InvitationValidateGate__loading">
          <p>Checking invitation…</p>
        </div>
      )}
    </div>
  );
}
